import React, { Component, Fragment } from 'react';
import moment from 'moment';
import { BeatLoader } from 'react-spinners';
import Datetime from 'react-datetime'
import { date_format } from '../../../../server/constants';
import NotificationSystem from 'react-notification-system';
import { get } from '../../../../server/actions'
import { showFile, _addNotification, _addNotificationError } from "../../../../server/util";

class DailySalesReport extends Component {
    constructor() {
        super()
        this.state = {
            loading: false,
            startDate: moment(moment().startOf('W')).startOf('D'),
            endDate: moment(moment().endOf('W')).endOf('D'),
            rptMonth: moment(),
            separateAlaCarte: false
        }
    }
    componentDidMount = () => {
        this._notificationSystem = this.refs.notificationSystem;
    }
    renderInput = (props, openCalendar, closeCalendar) => {
        return (
            <div>
                <input {...props} />
                <button type="button" className="input-group-addon" onClick={openCalendar}>
                    <i className="fa fa-calendar"> </i>
                </button>
            </div>
        );
    }
    dailySalesDownloadReport = () => {
        let _self = this;
        this.setState({ loading: true })
        const schoolId = sessionStorage.getItem('SchoolId');
        const districtId = 0;
        const schoolYear = sessionStorage.getItem('schoolYearValue');
        const start = moment(this.state.startDate).startOf('D');
        const end = moment(this.state.endDate).endOf('D');
        const separateAlaCarte = this.state.separateAlaCarte ? true : false;

        let _url = `/reports/menuItemsSold/${districtId}/${schoolId}/${schoolYear}?startDate=${moment(start).utc().format("YYYY-MM-DDTHH:mm:ss")}&endDate=${moment(end).utc().format("YYYY-MM-DDTHH:mm:ss")}`;

        if (this.state.separateAlaCarte) {
            _url += `&separateALaCarte=${separateAlaCarte}`;
        }

        _url += '&access_token=';
        get(_url)
            .then((response) => {
                if (!response.ok) {
                    if (response.status === 400 || response.status === 417 || response.status === 422) {
                        return response.json();
                    }
                }
                console.log('response', response);
                return response;
            }).then(res => {
                if (res.statusCode === 417) {
                    throw Error(res.statusMessage);
                } else if (res.statusCode === 422) {
                    throw Error(res.statusMessage);
                } else if (res.statusCode === 400) {
                    throw Error(res.statusMessage);
                } else {
                    return res.blob();
                }
            }).then(blob => {
                let filename = "ItemSalesSummaryReport";
                showFile(blob, filename);
                this.setState({ loading: false })
            }).catch(
                (error) => {
                    let msg = ''
                    if (typeof error === 'string') {
                        msg = error;
                    } else {
                        msg = error.message;
                    }
                    _addNotificationError(msg, _self)
                    this.setState({ loading: false })
                }
            )
    }

    render() {
        return (
            <Fragment>
                <NotificationSystem ref="notificationSystem" />
                <div className='sweet-loading' style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000' }}>
                    <BeatLoader
                        size={20}
                        color={'#ea7066'}
                        loading={this.state.loading}
                    />
                </div>
                <div className="row">
                    <div className="panel-p1 panel-primary col-md-offset-3 col-md-6">
                        <div className="panel-heading text-center">
                            <h3 className="panel-title"> Item Sales Summary</h3>
                        </div>
                        <div className="panel panel-primary">
                            <div className="panel-body">
                                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                    <label className="custom-label col-md-3 text-left" style={{ margin: '10px 0px' }}>Start Date</label>
                                    <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                        <Datetime ref='startCalendar' dateFormat={date_format()} timeFormat={false} closeOnSelect={true}
                                            value={this.state.startDate}
                                            onChange={(e) => {
                                                this.setState({ startDate: moment(e) })
                                            }} renderInput={this.renderInput} />
                                    </div>
                                </div>
                                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                    <label className="custom-label col-md-3 text-left" style={{ margin: '10px 0px' }}>End Date</label>
                                    <div className="input-group col-md-8 col-sm-12 col-xs-12">
                                        <Datetime ref='startCalendar' dateFormat={date_format()} timeFormat={false} closeOnSelect={true}
                                            value={this.state.endDate}
                                            onChange={(e) => {
                                                this.setState({ endDate: moment(e) })
                                            }} renderInput={this.renderInput} />
                                    </div>
                                </div>
                                {/*added checkbox for Separate A la Carte*/}
                                <div className="uploadFileInfo col-md-12 createmenu-month-group form-group">
                                    <label className="custom-label col-md-6 text-left">Separate A la Carte</label>
                                     <div className="input-group col-md-6 col-sm-12 col-xs-12">
                                        <input type="checkbox" name="separateAlaCarte" checked={this.state.separateAlaCarte} onChange={(e) => {
                                            this.setState({ separateAlaCarte: e.target.checked })
                                        }} />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-md-12">
                                    <button className="btn btn-success btn-sm" style={{ marginLeft: '37%' }} onClick={(e) => {
                                        e.preventDefault();
                                        this.dailySalesDownloadReport();
                                    }}> Download Report
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}
export default DailySalesReport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/Reports/FinancialReport/dailySalesReport.js